export default __webpack_public_path__ + "static/media/3.1e48cc6c.jpg";